import { baseAPI } from "../baseApi"

export const objectsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение структуры типов объектов и разделов
        fetchObjectTypesStructure: builder.query<any, any>({
            query: (args) => ({
                url: `objTypes/get?AuthToken=${args.token}`
            })
        }),
        // запрос на получение структуры типов объектов и разделов
        fetchAddressTypes: builder.query<any, any>({
            query: (args) => ({
                url: `address`
            })
        }),
    })
})

export const {
    useFetchObjectTypesStructureQuery,
    useLazyFetchObjectTypesStructureQuery,
    useLazyFetchAddressTypesQuery
} = objectsApiSlice


